const blocksContainer = document.querySelector('.information-page__content') as HTMLDivElement
const blockHeadings = blocksContainer?.querySelectorAll('h2') as NodeListOf<HTMLHeadingElement>
const navigationList = document.querySelector('.information-page__navigation__list') as HTMLUListElement

const setNavList = () => {
    if (blockHeadings.length > 0 && navigationList)
    {
        blockHeadings.forEach(item => {
            const heading = item.innerText
            const id = item.getAttribute('data-heading')

            const listItem = document.createElement('li')
            const linkItem = document.createElement('a')
            linkItem.href = '#' + id
            linkItem.innerText = heading

            listItem.appendChild(linkItem)
            navigationList.appendChild(listItem)
        })

        navigationList.querySelector('a').classList.add('in-view')
    }
}

const initIsInView = () => {
  if (blockHeadings.length > 0)
    {
        blockHeadings.forEach(item => {
            const itemlink = document.querySelector('a[href="#' + item.getAttribute('data-heading') + '"]')
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                  if (entry.isIntersecting) {
                    itemlink.classList.add('in-view')
                  } else {
                    itemlink.classList.remove('in-view')
                  }
                })
              }, { threshold: 1.0 })

              observer.observe(item.closest('.information-page__block'))
        })
    }
}








export default function initInformationPage()
{
    setNavList()
    initIsInView()

}